module.exports = __webpack_public_path__ + "static/media/jaguar.79528a48.png";